import { getDataViewOfTypedArray } from './utils';

export const MESSAGE_HEADER_LEN_BYTES = (
  32 + // size
  32 + // flags
  64 + // time
  32 // pto
) / 8;

export interface MessageStruct {
  size: number,
  flags: number,
  time: bigint,
  pto: number, // presentation time offset
  payload: Uint8Array
  flagsParsed: MessageFlags
}

export type MessageFlags = {
  payloadType: MessagePayloadType
  isCodecConfig: boolean
  isKeyframe: boolean
  isSyncpoint: boolean
}

export enum MessagePayloadType {
  IsoBox = 0,
  Json,
  Avc,
  Aac
}

export function parseMessageStruct(data: Uint8Array): MessageStruct {
  const dataView = getDataViewOfTypedArray(data);
  const size = dataView.getUint32(0, true);
  if (size !== data.byteLength) {
    throw new Error(`Assertion failed: msg.size=${size} != data.byteLength=${size}`);
  }
  const flags = dataView.getUint32(4, true);
  const time = dataView.getBigUint64(8, true);
  const pto = dataView.getInt32(16, true);
  const payload = data.subarray(MESSAGE_HEADER_LEN_BYTES);
  const flagsParsed = getMessageFlags(flags);
  const msgData: MessageStruct = {
    size,
    flags,
    time,
    pto,
    payload,
    flagsParsed
  };
  return msgData;
}

export function getMessageFlags(flags: number): MessageFlags {
  const payloadType = <MessagePayloadType> (flags & 0x000000FF);
  const isCodecConfig = (flags & 0x00000400) > 0;
  const isKeyframe = (flags & 0x00000200) > 0;
  const isSyncpoint = (flags & 0x00000100) > 0;
  return {
    payloadType,
    isCodecConfig,
    isKeyframe,
    isSyncpoint,
  }
}

export function getMessageJsonPayload(msg: MessageStruct): object {
  const txtDec = new TextDecoder();
  return JSON.parse(txtDec.decode(msg.payload));
}

